import ReservationDeepLinkRedirect from './ReservationDeepLinkRedirect';

export default ReservationDeepLinkRedirect;
